<template>
  <nav>
    <div class="mb-4">
      <logo class="fill-white" width="120" height="50" />
    </div>
    <Link
      v-for="item in menuItems"
      :key="item.label"
      class="group flex items-center py-3 text-indigo-300 hover:text-white mb-4"
      :href="item.href"
      :aria-label="item.label"
      :class="{ 'text-white': isUrl(item.urlMatch) }"
    >
      <i :class="`pi ${item.icon} mr-2 text-2xl`" />{{ item.label }}
    </Link>
    <div class="mt-auto mb-0">
      <Link
        class="group flex items-center gap-2 py-4 text-indigo-300 hover:text-white w-full transition-colors"
        :href="$routes.notifications()"
        aria-label="Notifications"
        :class="{ 'text-white': isUrl('notifications') }"
      >
        <span>Notificari</span>
        <span
          v-if="unreadCount > 0"
          class="bg-red-500 text-white text-xs rounded-full px-2 py-0.5 text-center"
        >
          {{ unreadCount > 9 ? '9+' : unreadCount }}
        </span>
      </Link>
      <Link
        class="group flex items-center py-4 text-indigo-300 hover:text-white"
        :href="profilMenuItem.href"
        :aria-label="profilMenuItem.label"
        :class="{ 'text-white': isUrl(profilMenuItem.urlMatch) }"
      >
        {{ profilMenuItem.label }}
      </Link>
      <Link
        class="group flex items-center py-4"
        :href="$routes.destroy_user_session()"
        method="delete"
        aria-label="Logout"
      >
        <div class="text-indigo-300 group-hover:text-white">Logout</div>
      </Link>
    </div>
  </nav>
</template>

<script>
import { Link } from '@inertiajs/vue3';
import Logo from '@/Shared/Logo.vue';
import notificationsService from '@/services/notificationsService';

export default {
  components: {
    Link,
    Logo,
  },
  data() {
    return {
      menuItems: [
        {
          label: 'Dashboard',
          href: this.$routes.root(),
          icon: 'pi-globe',
          urlMatch: '',
        },
        {
          label: 'Utilizatori',
          href: this.$routes.users(),
          icon: 'pi-users',
          urlMatch: 'users',
        },
        {
          label: 'Cursuri',
          href: this.$routes.courses(),
          icon: 'pi-book',
          urlMatch: 'courses',
        },
        {
          label: 'Evaluari',
          href: this.$routes.quiz_results(),
          icon: 'pi-check-square',
          urlMatch: 'quiz_results',
        },
        {
          label: 'Feedbacks',
          href: this.$routes.feedbacks(),
          icon: 'pi-cloud-upload',
          urlMatch: 'feedbacks',
        },
      ],
      profilMenuItem: {
        label: 'Profil',
        href: this.$routes.admin_profile(),
        icon: 'pi-user',
        urlMatch: 'admin_profile',
      },
    };
  },
  computed: {
    unreadCount() {
      return notificationsService.unreadCount.value;
    },
  },
  methods: {
    isUrl(...urls) {
      let currentUrl = this.$page.url.substr(1);

      if (urls[0] === '') {
        return currentUrl === '';
      }

      return urls.filter((url) => currentUrl.startsWith(url)).length;
    },
  },
};
</script>
